import React, { useState } from "react";
import { topProducts } from "../../assets/data/data";
import Heading from "../../common/Heading";
import ProductItem from "../product/ProductItem";

const TopProduct = () => {
  const [data, setData] = useState(topProducts);
  const allCategories = ["all", ...new Set(data.map((item) => item.category))];
  const [category, setCategory] = useState(allCategories);
  const handleFilter = (category) => {
    const newItem = topProducts.filter((item) => item.category === category);
    setData(newItem);
    if (category === "all") {
      setData(topProducts);
      return;
    }
  };
  return (
    <>
      <section className="topproduct">
        <div className="container">
          <div className="head">
            <Heading
              title="Top Selling Products"
              decs="Meet our newbies! The latest templates uploaded to the marketplace."
            />
            <div className="category">
              {category.map((category, id) => (
                <button
                  className="button"
                  onClick={() => handleFilter(category)}
                  key={id}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
          <ProductItem data={data} />
        </div>
      </section>
    </>
  );
};

export default TopProduct;
